var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-blank"},[_c('Blank',{attrs:{"text":"功能升级维护中，敬请期待。"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }